import styles from './scrolldown.module.scss';
import { ScrollDown } from '../../image';
export default function ScrolDown(props) {
  return (
    <div className={styles['scroll-down']}>
      <span onClick={() => props.fullpageApi.moveSectionDown()}>
        <ScrollDown />
      </span>
    </div>
  );
}
